import * as Yup from 'yup';
import { messages } from 'app/config/constants';

export const caseSegmentValidationSchema = Yup.object().shape({
  segments: Yup.array().of(
    Yup.object().shape({
      description: Yup.string().required(messages.MANDATORY_FIELD),
    }),
  )
})
